import {
  List,
  Datagrid,
  ImageField,
  TextField,
  NumberField,
  EmailField,
  ChipField,
  DateField,
  BooleanField,
  ArrayField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  ImageInput,
  TextInput,
  NumberInput,
  // ReferenceInput,
  DateTimeInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  Create,
  Show,
  SimpleShowLayout,
  SelectInput,
  useRecordContext,
  useNotify,
} from 'react-admin'
import { useState } from 'react'

import { Grid, Paper, Button, CircularProgress } from '@mui/material'
import { testMyFriendCongratulation } from '../dataProvider'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

const TestCongratulationButton = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const [loading, setLoading] = useState(false)

  const handleTestCongratulation = async () => {
    if (!record || !record.id) {
      notify('No friend record found', { type: 'error' })
      return
    }

    setLoading(true)
    try {
      const params = {
        friendId: record.id,
        eventId: record.events[0].id,
      }
      await testMyFriendCongratulation(params)
      notify('Test congratulation sent successfully!', { type: 'success' })
    } catch (error) {
      notify('Failed to send test congratulation', { type: 'error' })
      console.error('Error sending test congratulation:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleTestCongratulation}
      disabled={loading}
      sx={{ mt: 2 }}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
    >
      {loading ? 'Testing...' : 'Test Friend Congratulation'}
    </Button>
  )
}

export const FriendList = () => (
  <List queryOptions={{ meta: { isMy: true } }}>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <ImageField source="avatarUrl" title="avatarUrl" />
      <TextField source="fristName" />
      <TextField source="lastName" />
      <NumberField source="utcOffset" />
      <ArrayField source="events">
        <Datagrid>
          <TextField source="title" />
          <TextField source="context" />
          <DateField source="date" />
          <BooleanField source="isConfirmationRequired" />
          <BooleanField source="isOn" />
        </Datagrid>
      </ArrayField>
      <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
    </Datagrid>
  </List>
)

export const FriendEdit = () => (
  <Edit queryOptions={{ meta: { isMy: true } }} mutationOptions={{ meta: { isMy: true } }}>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <ImageInput source="avatarUrl" accept="image/*">
              <ImageField source="src" title="title" />
            </ImageInput>
          </Paper>
        </Grid>
        
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextInput source="fristName" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="lastName" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput source="utcOffset" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="email" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput source="language" choices={[
                  { id: 'eng', name: 'English' },
                  { id: 'rus', name: 'Russian' },
                  { id: 'ukr', name: 'Ukrainian' }
                ]} fullWidth />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextInput source="facebookId" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="instagramId" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="linkedInId" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="telegramId" fullWidth />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInput source="bio" fullWidth multiline rows={3} />
              </Grid>
              <Grid item xs={12}>
                <TextInput source="personalContext" fullWidth multiline rows={3} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <ArrayInput source="events">
              <SimpleFormIterator sx={{ '& .RaSimpleFormIterator-form': { display: 'grid', gridTemplateColumns: '6fr 2fr 1fr 1fr 1fr', gap: 2, alignItems: 'start', '& > :nth-of-type(3)': { gridColumn: '1 / -1' }, '& > :nth-of-type(4), & > :nth-of-type(5)': { gridColumn: 'span 1' } } }}>
                <TextInput source="title" />
                <DateTimeInput source="date" />
                <TextInput source="context" multiline rows={2} />
                <BooleanInput source="isConfirmationRequired" />
                <BooleanInput source="isOn" />
              </SimpleFormIterator>
            </ArrayInput>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <TestCongratulationButton />
          </Paper>
        </Grid>
      </Grid>
    </SimpleForm>
  </Edit>
)

export const FriendCreate = () => (
  <Create queryOptions={{ meta: { isMy: true } }} mutationOptions={{ meta: { isMy: true } }}>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <ImageInput source="avatarUrl" accept="image/*">
              <ImageField source="src" title="title" />
            </ImageInput>
          </Paper>
        </Grid>
        
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextInput source="fristName" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="lastName" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <NumberInput source="utcOffset" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="email" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput source="language" choices={[
                  { id: 'eng', name: 'English' },
                  { id: 'rus', name: 'Russian' },
                  { id: 'ukr', name: 'Ukrainian' }
                ]} fullWidth />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextInput source="facebookId" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="instagramId" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="linkedInId" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextInput source="telegramId" fullWidth />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInput source="bio" fullWidth multiline rows={3} />
              </Grid>
              <Grid item xs={12}>
                <TextInput source="personalContext" fullWidth multiline rows={3} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <ArrayInput source="events">
              <SimpleFormIterator sx={{ '& .RaSimpleFormIterator-form': { display: 'grid', gridTemplateColumns: '6fr 2fr 1fr 1fr 1fr', gap: 2, alignItems: 'start', '& > :nth-of-type(3)': { gridColumn: '1 / -1' }, '& > :nth-of-type(4), & > :nth-of-type(5)': { gridColumn: 'span 1' } } }}>
                <TextInput source="title" />
                <DateTimeInput source="date" />
                <TextInput source="context" multiline rows={2} />
                <BooleanInput source="isConfirmationRequired" />
                <BooleanInput source="isOn" />
              </SimpleFormIterator>
            </ArrayInput>
          </Paper>
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
)

export const FriendShow = () => (
  <Show queryOptions={{ meta: { isMy: true } }}>
    <SimpleShowLayout>
      <ImageField source="avatarUrl" title="avatarUrl" />
      <TextField source="fristName" />
      <TextField source="lastName" />
      <NumberField source="utcOffset" />
      <TextField source="facebookId" />
      <TextField source="instagramId" />
      <TextField source="linkedInId" />
      <TextField source="telegramId" />
      <EmailField source="email" />
      <TextField source="language" />
      <TextField source="bio" />
      <TextField source="personalContext" />
      <ChipField source="postingType" />
      <ArrayField source="events">
        <Datagrid>
          <TextField source="title" />
          <TextField source="context" />
          <DateField source="date" />
          <BooleanField source="isConfirmationRequired" />
          <BooleanField source="isOn" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
)
